export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/20e765fe22790b7f1075e229233d4cab.svg";